export default {
  data() {
    return {
      slicingHeadlightTypes: {
        normal: {
          sliceCount: 10,
          slicingMode: true,
        },
        small: {
          sliceCount: 5,
          slicingMode: true,
        },
      },
    }
  },
  computed: {
    getHeadlightTypesNames() {
      return (data, slicingMode, sliceCount) => {
        return data.slice(0, slicingMode ? sliceCount : data.length).join(', ')
      }
    },
  },
}
